import { initialState } from './initial';
import { actionTypes } from './actions';

export function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.ACTION_PROCESSING:
      return {
        ...state,
        actionProcessing: action.payload,
      };

    case actionTypes.GET_CURRENCY_RATE:
      return {
        ...state,
        rate: action.payload?.rate,
        agentCommission: action.payload?.agent_comission,
      };

    case actionTypes.DEPOSIT_INIT:
      return {
        ...state,
        depositInitData: action.payload,
      };

    case actionTypes.GET_DEPOSIT_INFO:
      return {
        ...state,
        depositInfo: action.payload,
      };

    case actionTypes.TOP_UP_SUCCESS:
      return { ...state, paymentLink: action.payload.invoice_url, isPaymentReady: true, amount: action.payload.amount };

    case actionTypes.CLEAR_PAYMENT_LINK:
      return { ...state, paymentLink: '', isPaymentLoading: false, isPaymentReady: false };

    case actionTypes.GET_DEPOSIT_HISTORY:
      return {
        ...state,
        depositHistory: {
          deposits: action.payload?.deposits || [],
          count: action.payload?.count || 0,
        },
      };

    default:
      return state;
  }
}
